import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import InteractiveTool from './components/InteractiveTool';
import GlazingCalculator from './components/GlazingCalculator';
import ExpertiseSection from './components/ExpertiseSection';
import B2BAdvantages from './components/B2BAdvantages';
import UniversalService from './components/UniversalService';
import Reassurance from './components/Reassurance';
import WhatsAppBenefits from './components/WhatsAppBenefits';
import ContactFormSection from './components/ContactFormSection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Détermine si on a scrollé
      setIsScrolled(currentScrollY > 50);
      
      // Cache la navbar quand on scroll vers le bas, montre quand on scroll vers le haut
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} showNavbar={showNavbar} />
      <Hero />
      <TrustSection />
      <InteractiveTool />
      <GlazingCalculator />
      <ExpertiseSection />
      <B2BAdvantages />
      <UniversalService />
      <Reassurance />
      <WhatsAppBenefits />
      <ContactFormSection />
      <Footer />
    </div>
  );
}
